module.exports = __webpack_public_path__ + "static/media/WordBounty.f7198b13.PNG";